import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap';

import { CBMError, VildVersion } from 'app/models';
import { VildVersionService } from 'app/services';

@Component({
  selector: 'app-dialog-vild-delete',
  templateUrl: './dialog-vild-delete.component.html'
})
export class DialogVildDeleteComponent {
  @ViewChild('deleteVildVersionDialog') deleteVildVersionDialog: ModalDirective;

  @Output() onConfirm = new EventEmitter<boolean>();
  @Input() vildVersion: VildVersion;

  private readonly modalTimeout = 2000;

  public isDeletingVild = false;
  public vildVersionIsSuccessfullyDeleted = false;
  public deleteVildErrorMessages: CBMError[] = [];

  constructor(public readonly vildVersionService: VildVersionService) {}

  public show(): void {
    this.deleteVildVersionDialog.show();
  }

  public stopDeleteVildVersion(): void {
    this.deleteVildVersionDialog.hide();
  }

  public deleteVildVersion(): void {
    this.isDeletingVild = true;
    this.deleteVildErrorMessages = [];

    if (this.vildVersion) {
      this.vildVersionService.deleteVildVersion(this.vildVersion.id).subscribe(
        () => {
          this.vildVersionIsSuccessfullyDeleted = true;

          setTimeout(() => {
            this.isDeletingVild = false;
            this.onConfirm.emit(true);
            this.deleteVildVersionDialog.hide();
          }, this.modalTimeout);
        },
        (errors: CBMError[]) => {
          this.isDeletingVild = false;
          this.deleteVildErrorMessages = errors;
          this.deleteVildVersionDialog.hide();
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-vild-delete/dialog-vild-delete.component.ts